import React from 'react';
import { FaTimes,FaBars } from 'react-icons/fa';
import {
    Link
  } from "react-router-dom";

import "./Navbar.css"
const Navbar = () => {
    const showmenu=()=>{
        document.getElementById("nav-links").style.right="0";
        console.log("object");
    }
  const hidemenu=()=>{
        document.getElementById("nav-links").style.right="-200px";
    }
    return (
        <section className="headerr">
        <nav>
        <Link  className="logo text-link" to="/">Md Imranul Haque</Link>
            <div className="nav-links" id="nav-links">
                <h5 onClick={hidemenu}><FaTimes/></h5>
                <ul onClick={hidemenu}>
                    <li className="li"><Link to="/home">HOME</Link></li>
                    <li className="li"><Link to="/projects">MY WORKS</Link></li>
                    <li className="li"><Link to="/about">ABOUT</Link></li>
                    {/* skip services part just for now ! if needed than work for it . */}
                    {/* <li className="li"><Link to="/services">SERVICES</Link></li> */}
                    <li className="li"><Link to="/blogs">BLOGS</Link></li>
                    <li className="resume"><Link to="/contact">CONTACT</Link></li>
                    <li className="resume"><a href="https://drive.google.com/uc?export=download&id=1vnh5nGTsLPae_MFfLpOZ5glnLSX3DSL8"  target="_blank" rel="noopener noreferrer">DOWNLOAD RESUME</a></li>                    
                </ul>
            </div>
            <div className="navend">
            <h5 onClick={showmenu}> <FaBars/></h5>
            </div>
        </nav>
    </section>
    );
};

export default Navbar;